var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('NFSeList')],1),(_vm.showModal)?_c('CargaDados',{attrs:{"opened":_vm.showModal},on:{"closeModalCarga":function($event){//@ts-ignore
        _vm.closeModalCarga()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }